// extracted by mini-css-extract-plugin
export default {"body":"styles_body__roEeB","tab":"styles_tab__H+7+g","activeTab":"styles_activeTab__3xAOT","tabs":"styles_tabs__ao2SF","supervisionBody":"styles_supervisionBody__oHh7V"};